import React from 'react';
import Modal from 'react-modal';
import QRCode from 'react-qr-code';

import sessionStore from 'utils/sessionStore';

import { useRouter } from 'next/router';
import { IOS_APP_STORE_URL, ANDROID_PLAY_STORE_URL } from 'utils/app';

import { useGlobalConfig } from 'contexts/GlobalConfig';

import { CrossSvg } from 'components/SorraSvg';

const AppDownloadModal = (props) => {
  // const { isOpen, setIsOpen } = props;
  // const router = useRouter();
  const { showAppDownloadModal, setShowAppDownloadModal } = useGlobalConfig();
  const DOWNLOAD_URL =
    typeof window !== 'undefined' ? `${window.location.origin}/download` : '';
  return (
    <Modal
      isOpen={showAppDownloadModal}
      onRequestClose={() => {
        setShowAppDownloadModal(false);
        sessionStore.setShowAppDownloadPopup(false);
      }}
      shouldCloseOnOverlayClick={false}
      className="relative mx-[18px] w-full max-w-[662px] overflow-hidden rounded-2xl bg-white lg:mx-0"
      overlayClassName="z-50 absolute flex items-center justify-center top-0 left-0 right-0 bottom-0 w-full h-full bg-[#111928] bg-opacity-50"
    >
      <div
        className="relative w-full px-9 pt-4 lg:px-0 lg:pt-0"
        style={{
          background:
            'radial-gradient(110.89% 125.8% at 82.42% 43.85%, rgba(253, 203, 212, 0.50) 0%, rgba(253, 203, 212, 0.22) 40%, #FDCBD4 90%), linear-gradient(259deg, #FFF -5.92%, #FFF 37.14%, #FFF6ED 67.89%, #FFEDDD 96.6%)',
        }}
      >
        <div className="absolute right-4 top-4 flex justify-end">
          <button
            className="h-6 w-6 cursor-pointer"
            onClick={() => {
              setShowAppDownloadModal(false);
              sessionStore.setShowAppDownloadPopup(false);
            }}
          >
            <CrossSvg color="#4A4A4A" />
          </button>
        </div>
        <div className="flex flex-col pl-0 pr-0 lg:flex-row lg:pl-12 lg:pr-9">
          <div className="flex flex-none flex-col items-center justify-center pb-0 pt-8 lg:flex-1 lg:items-start lg:pb-9 lg:pt-12">
            <img src="/images/sorra.png" className="h-[26px] object-contain" />
            <p className="ml-0 mt-3 text-4xl font-bold text-sorra-pink lg:-ml-1 lg:mt-2.5">
              立即下載手機app
            </p>
            <p className="mt-3 text-base font-medium text-[#4A4A4A] lg:mt-1.5">
              解鎖限定活動及兌換限定美妝產品！
            </p>
            <div className="mt-8 flex flex-row items-center justify-center gap-x-6 lg:mt-7">
              <div className="h-[99px] w-[99px] rounded-[4px] bg-white p-1">
                <QRCode
                  value={DOWNLOAD_URL}
                  style={{ height: '100%', width: '100%' }}
                />
              </div>
              <div className="flex w-[135px] flex-col justify-center gap-y-2">
                <button
                  className="h-10 w-full"
                  onClick={() => {
                    window.open(IOS_APP_STORE_URL, '_blank');
                  }}
                >
                  <img
                    src="/images/ios-download.png"
                    className="h-full w-full object-contain"
                  />
                </button>
                <button
                  className="h-10 w-full"
                  onClick={() => {
                    window.open(ANDROID_PLAY_STORE_URL, '_blank');
                  }}
                >
                  <img
                    src="/images/android-download.png"
                    className="h-full w-full object-contain"
                  />
                </button>
              </div>
            </div>
          </div>
          <div className="relative h-[226px] flex-none overflow-visible px-4 lg:h-[328px] lg:flex-1 lg:overflow-hidden lg:px-0">
            <div className="-bottom-auto absolute left-4 right-4 top-[38px] w-auto lg:-bottom-[110px] lg:left-auto lg:right-[36px] lg:top-auto lg:w-[196px]">
              <img src="/images/mobile.png" className="w-full object-contain" />
            </div>
            <div className="absolute -right-[26px] bottom-0 w-[78px] lg:right-0">
              <img
                src="/images/mobile-rabbit.png"
                className="w-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AppDownloadModal;
